<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <v-dialog v-model="dialogSend" persistent max-width="400">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Confirmación
          </v-card-title>
          <v-card-text>
            <h4 class="mt-5">
              ¿Desea enviar al módulo Camujal los elementos seleccionados?
            </h4>

            <h4 class="mt-5">
              <strong class="yellow--text"> Cantidad : {{ selectedMG.length }}</strong>
            </h4>
          </v-card-text>
          <v-card-actions class="text-center">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogSend = false">
              <v-icon left> mdi-cancel</v-icon> Volver
            </v-btn>
            <v-btn color="primary" :disabled="sending" text @click="sendSynch()">
              <v-icon left>mdi-send</v-icon> Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateStatus" persistent max-width="400">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Actualizar estatus | {{ specialityName }}
          </v-card-title>
          <v-card-text>
            <h4 class="mt-5">
              ¿Desea cambiar el estado de los elementos seleccionados?
            </h4>

            <h4 class="mt-5">
              <strong class="yellow--text"> Cantidad : {{ selected.length }}</strong>
              <br />
                <strong v-if="$utilFront.nonEmpty(newStatusText)" class="green--text">
                  Nuevo estatus : {{ newStatusText }}</strong>
            </h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogUpdateStatus = false">
              <v-icon left> mdi-cancel</v-icon> Volver
            </v-btn>
            <v-btn color="primary" :disabled="sending" text @click="updateStatus()">
              <!-- <v-btn
              color="primary"
              :disabled="
                sending ||
                  (this.$utilFront.isEmpty(model.status) &&
                    $utilFront.nonEmptyList(status))
              "
              text
              @click="updateStatus()"
            > -->
              <v-icon left>mdi-content-save-outline</v-icon> Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogInformation" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="green darken-1">
            <v-btn icon dark @click="dialogInformation = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>I n f o r m a c i ó n </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialogInformation = false">
                Salir
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader class="ml-10 mr-10 mt-10">
            <v-subheader>
              <h2><v-icon left>mdi-account-circle</v-icon> Paciente</h2>
            </v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <!-- <v-col>
                    {{model}}
                    <v-text-field  disabled   
                    :value="model." label="Sucursal"
                    prepend-inner-icon="mdi-home"/>
                  </v-col> -->
                  <v-col>
                    <v-text-field disabled :value="model.idPatient" label="Id Paciente" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.fullNamePatient" label="Paciente" />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <!-- <v-divider></v-divider> -->
          <v-list three-line subheader class="ml-10 mr-10 mt-10" v-if="viewTab(4) || viewTab(5)">
            <v-subheader>
              <h2>
                <v-icon left>mdi-pencil-box-outline</v-icon> Estudio

                <v-chip class="ml-10" color="warning" outlined v-show="model.typeCancel == 3">
                  Reportado
                </v-chip>
                <v-chip class="ml-10" color="error" outlined v-show="model.typeCancel == 4">
                  Cancelado
                </v-chip>
              </h2>
            </v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col>
                    <v-text-field disabled :value="model.idStudy" label="Id Estudio" />
                  </v-col>
                  <v-col v-if="this.tab != 4">
                    <v-text-field disabled :value="(model.accessionNumber && model.accessionNumber.trim()) 
                      ? model.accessionNumber 
                      : 'N/A'"
                      label="Accession number"/>
                  </v-col>
                  <v-col v-if="this.tab == 4">
                    <v-text-field disabled :value="model.accessionNumber" label="ID etiqueta" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.modality" label="Modalidad" />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col>
                    <v-text-field disabled :value="model.studyModalityName" label="Estudio" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.registrationDate" label="Fecha de estudio" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.quantityImages > 0 
                  ? model.quantityImages 
                  : 'N/A'"
                  label="Cantidad imágenes" />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="viewTab(5)">
              <v-list-item-content>
                <div class="container">
                  <div class="d-flex justify-center">
                    <v-col class="d-flex justify-space-around">
                      <v-btn color="warning" @click="downloadViewer()" :disabled="sending" class="mr-2 white--text" v-if="model.studyModalityName !== 'PAPANICOLAOU'">
                        <v-icon color="white" dark left>mdi mdi-eye</v-icon>
                        Visualizador
                      </v-btn>

                      <v-btn color="blue" class="mr-2 white--text" @click="downloadZIP()" :disabled="sending" v-if="model.studyModalityName !== 'PAPANICOLAOU'">
                        <v-icon color="white" dark left>mdi-folder-download</v-icon>
                        Archivos DICOM
                      </v-btn>
                    </v-col>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list three-line subheader class="ml-10 mr-10 mt-10" v-if="viewTab(3)">
            <v-subheader>
              <h2><v-icon left>mdi-pill</v-icon> Receta</h2>
            </v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col>
                    <v-text-field disabled :value="model.idPrescription" label="Id receta" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.prescriptionDate" label="Fecha de receta" />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-divider></v-divider>
                <v-subheader>Productos recetados</v-subheader>
                <v-row>
                  <v-col>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Clave</th>
                            <th>Producto</th>
                            <th>Descripción</th>
                            <th class="text-center">Cantidad prescrita</th>
                            <!-- <th class="text-center">Cantidad dispensada</th> -->
                          </tr>
                        </thead>

                        <tbody v-for="(product, index) in productsPrescription" :key="index">
                          <tr>
                            <td>{{ product.product_key }}</td>
                            <td>{{ product.name }}</td>
                            <td>{{ product.text }}</td>
                            <td class="text-center">{{ product.request }}</td>
                            <!-- <td>
                              <v-row align="center" justify="center">
                                <v-col
                                  ><v-text-field
                                    disabled
                                    type="number"
                                    :max="product.request"
                                    v-model="product.dispensed"
                                    :suffix="`/${product.request}`"
                                  ></v-text-field
                                ></v-col>
                              </v-row>
                            </td> -->
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <!-- <v-divider></v-divider> -->
          <v-list three-line subheader class="ml-10 mr-10 mt-10">
            <v-subheader>
              <h2>
                <v-icon left>mdi-close-circle-outline</v-icon> Cancelación
              </h2>
            </v-subheader>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col>
                    <v-text-field disabled :value="model.nameDoctorCanceled" label="Cancelado por" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.cancellationDate" label="Fecha de cancelación" />
                  </v-col>
                  <v-col>
                    <v-text-field disabled :value="model.reasonCanceled" label="Razón" />
                  </v-col>
                  <v-col v-show="viewTab(4) || viewTab(5)">
                    <v-text-field disabled label="Último estatus" value="Por comenzar" v-show="model.lastStatus == 1" />
                    <v-text-field disabled label="Último estatus" value="En proceso" v-show="model.lastStatus == 2" />
                    <v-text-field disabled label="Último estatus" value="Por cerrar"
                      v-show="model.lastStatus == 3 && viewTab(5)" />
                    <v-text-field disabled label="Último estatus" value="Por validar"
                      v-show="model.lastStatus == 3 && viewTab(4)" />
                    <v-text-field disabled label="Último estatus" value="Reportado" v-show="model.lastStatus == 4" />
                    <v-text-field disabled label="Último estatus" value="Por interpretar"
                      v-show="model.lastStatus == 5" />
                    <v-text-field disabled label="Último estatus" value="Interpretado" v-show="model.lastStatus == 6" />
                    <v-text-field disabled label="Último estatus" value="Entregado" v-show="model.lastStatus == 7" />
                    <v-text-field disabled label="Último estatus" value="Emergencia" v-show="model.lastStatus == 8" />
                    <v-text-field disabled label="Último estatus" value="Pendiente" v-show="model.lastStatus == 9" />
                    <v-text-field disabled label="Último estatus" value="Por atender" v-show="model.lastStatus == 10" />
                    <v-text-field disabled label="Último estatus" value="No presentó" v-show="model.lastStatus == 11" />
                    <v-text-field disabled label="Último estatus" value="Cancelado" v-show="model.lastStatus == 12" />
                    <v-text-field disabled label="Último estatus" value="Validado" v-show="model.lastStatus == 13" />
                    <v-text-field disabled label="Último estatus" value="Verificación de imagen"
                      v-show="model.lastStatus == 14" />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-container>
            <div name="filtros" class="mb-4 mt-5">


              <v-row align="baseline" dense justify="center" class="text-center">
                <branch-offices-list :classOfDiv="cols"
                 v-on:triggerChange="branchOfficeSelected" 
                 :model="idBranchOfficeSelected"
                 />

                <v-col cols="12" md="3" xl="3" sm="3">
                  <div id="handCalendar">
                    <vc-date-picker color="green" v-model="date" is-range :max-date="new Date()">
                      <template v-slot="{ inputEvents }">
                        <div class="flex justify-center items-center">
                          <v-text-field v-on="inputEvents.start" :value="dateCompuded" label="Seleccionar fecha..."
                            :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'" @click:append="clearCalendar"
                            :disabled-input="validData"></v-text-field>
                        </div>
                      </template>
                    </vc-date-picker>
                  </div>
                </v-col>

                <v-col md="3" sm="12">
                  <v-text-field v-model="search" label="Buscar" :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                    @click:append="search = ''"></v-text-field>
                </v-col>

                <v-col md="3" sm="12">
                  <v-btn color="primary" v-if="$utilFront.withPermission($prm.ACTIVATE_STUDIES)" small
                    @click="dialogUpdateStatus = true" :disabled="selected.length == 0 || sending">
                    <v-icon left> mdi-refresh </v-icon>
                    Actualizar estatus {{  selected.length }}
                  </v-btn>
                  <br />

                  <v-btn color="secondary" class="mt-4" v-if="tab == 5 && $utilFront.withPermission($prm.SEND_CAMUJAL)"
                    small @click="dialogSend = true" :disabled="sending || selectedMG.length == 0">
                    <v-icon left> mdi-send </v-icon>
                    Enviar a Camujal {{  selectedMG.length }}
                  </v-btn>
                </v-col>
              </v-row>

            </div>


            <v-tabs icons-and-text centered fixed-tabs v-model="tab">
              <!-- <v-tabs  centered fixed-tabs     background-color="green darken-2" dark> -->
              <v-tab class="mt-2 mb-3">
                Somatometría <v-icon right>mdi-book-edit</v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Consultas <v-icon right> mdi-stethoscope </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Dental <v-icon right> mdi-tooth </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Farmacia <v-icon right>mdi-pill </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Laboratorio <v-icon right>mdi-microscope </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Imagen <v-icon right>mdi-camera-iris </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Psicología <v-icon right>mdi-brain </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Optometría <v-icon right>mdi-eye </v-icon></v-tab>
              <v-tab class="mt-2 mb-3">
                Audiometría <v-icon right>mdi-ear-hearing </v-icon>
              </v-tab>
              <!-- <v-tab class="mt-2 mb-3" v-if="$utilFront.SHOW_COLPOSCOPY">
                Colposcopia <v-icon right>mdi-crosshairs-gps </v-icon>
              </v-tab> -->
              <v-tab class="mt-2 mb-3" v-if="$utilFront.SHOW_TELEMEDICINE">
                Telemedicina <v-icon right>mdi-monitor-dashboard </v-icon>
              </v-tab>
              <v-tab-item name="somatometry" class="mt-15 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.somatometry" dense item-key="idUnique" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="medicalPractice" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.medicalPractice" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="dental" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.dental" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="pharmacy" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.pharmacy" dense item-key="idPrescription" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click="viewPrescription(item)" :disabled="sending">
                              <v-icon color="blue" v-bind="attrs" v-on="on">
                                mdi-information-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Información de receta
                            {{ item.idPrescription }}</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="laboratory" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.laboratory" dense item-key="idStudy" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                      <template v-slot:[`item.nameTypeCancel`]="{ item }">
                        <v-chip color="warning" outlined v-show="item.typeCancel == 3">
                          Reportado
                        </v-chip>
                        <v-chip color="error" outlined v-show="item.typeCancel == 4">
                          Cancelado
                        </v-chip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click="viewStudy(item)">
                              <v-icon color="blue" v-bind="attrs" v-on="on">
                                mdi-information-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Información de estudio {{ item.idStudy }}</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="image" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table
                      :headers="headers.image"
                      dense
                      item-key="idStudy"
                      :items="list"
                      :items-per-page="10"
                      :footer-props="{
                        'items-per-page-text': 'Elementos por página',
                        'items-per-page-all-text': 'Todo'
                      }"
                      no-results-text="Sin resultados coincidentes con la búsqueda"
                      loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles"
                      :loading="sending"
                      :search="search"
                      v-model="selected"
                      fixed-header
                      height="auto"
                      :single-select="false"
                      :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)"
                    >
                      <template v-slot:[`item.nameTypeCancel`]="{ item }">
                        <v-chip color="warning" outlined v-show="item.typeCancel == 3">
                          Reportado
                        </v-chip>
                        <v-chip color="error" outlined v-show="item.typeCancel == 4">
                          Cancelado
                        </v-chip>
                      </template>

                      <template v-slot:[`item.studyModalityName`]="{ item }">
                        {{ item.studyModalityName }}
                        <br/>
                        <v-tooltip top v-if="item && item.statusSend === 1 && item.modalityAcronym === 'MG'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="secondary" class="mr-2" v-bind="attrs" v-on="on">
                              mdi-send
                            </v-icon>
                          </template>
                          <span>Por enviar a Camujal</span>
                        </v-tooltip>
                        <v-tooltip top v-if="item.statusSend == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="primary" class="mr-2" v-bind="attrs" v-on="on">
                              mdi-send
                            </v-icon>
                          </template>
                          <span>Enviado a Camujal</span>
                        </v-tooltip>
                      </template>

                      <template v-slot:[`item.accessionNumber`]="{ item }">
                        {{ item.accessionNumber || 'N/A' }}
                      </template>

                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click="viewStudy(item)" v-bind="attrs" v-on="on">
                              <v-icon color="blue">mdi-information-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Información de estudio {{ item.idStudy }}</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="psychology" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.psychology" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item name="optometry" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.optometry" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item name="audiometry" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.audiometry" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- <v-tab-item name="colposcopy" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.colposcopy" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item> -->
              <v-tab-item name="telemedicine" class="mt-10 mb-10">
                <v-card>
                  <v-card-text>
                    <v-data-table :headers="headers.telemedicine" dense item-key="idMedicalPractice" :items="list"
                      :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                      no-data-text="Sin resultados disponibles" :loading="sending" :search="search" v-model="selected"
                      fixed-header height="auto" :single-select="false" :show-select="$utilFront.withPermission($prm.ACTIVATE_STUDIES)
      ">
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-card-text>

        <v-card-actions class="text-center"> </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import { CamujalService } from "@/app/services";

import moment from "moment";
import Datatable from "@/components/Datatable.vue";
import Sidebar from "@/components/Sidebar";
import {
  StudyRequest,
  StudyFinishedRequest,
  CancelledRequest,
  DownloadZipRequest,
  SpecialityRequest,
  PharmacyPrescriptionRequest,
  ReportPDFRequest,
} from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import Loader from "../../components/Loader.vue";

export default {
  name: "EstudiosReportadosDescartados",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    AutoLogout,
    BranchOfficesList,
    Loader,
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
  },
  data: () => ({
    dialogUpdateStatus: false,
    dialogInformation: false,
    dialogSend: false,
    tab: null,
    specialityName: "",
    search: "",
    sending: false,
    date: "",
    dateModel: { startDate: "", endDate: "" },
    list: [],
    encabezado: {
      icono: "mdi-file-excel",
      texto: "Reportados y cancelados",
    },
    headers: {
      somatometry: [
        { text: "Id Paciente", value: "idPatient", align: "center" },
        { text: "Paciente", value: "fullNamePatient", align: "center" },
        { text: "Especialidad", value: "specialities", align: "center" },
        { text: "Estudios", value: "studies", align: "center" },
        { text: "Cancelado por", value: "fullNameCancel", align: "center" },
        { text: "Fecha cancelación", value: "cancelDate", align: "center",},
        { text: "Razón", value: "reason", align: "left", width: "280px" },
      ],
      medicalPractice: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
      dental: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
      pharmacy: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id receta", value: "idPrescription", align: "center" },
        { text: "Fecha receta", value: "prescriptionDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      laboratory: [
        { text: "ID paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id Estudio", value: "idStudy", align: "center" },
        { text: "ID etiqueta", value: "accessionNumber", align: "center" },
        { text: "Modalidad", value: "modality", align: "center" },
        { text: "Estudio", value: "studyModalityName", align: "center" },
        // { text: "Estatus", value: "nameTypeCancel", align: "center" },
        { text: "Fecha estudio", value: "registrationDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        {
          text: "Fecha de cancelación",
          value: "cancellationDate",
          align: "center",
        },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      image: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id Estudio", value: "idStudy", align: "center" },
        { text: "Accession number", value: "accessionNumber", align: "center" },
        { text: "Modalidad", value: "modality", align: "center" },
        { text: "Estudio", value: "studyModalityName", align: "center" },
        { text: "Fecha estudio", value: "registrationDate", align: "center" },
        { text: "Estatus", value: "nameTypeCancel", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      psychology: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
      optometry: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
      audiometry: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
      colposcopy: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px"},
      ],
      telemedicine: [
        { text: "Id paciente", value: "idPatient", align: "center" },
        {
          text: "Paciente",
          value: "fullNamePatient",
          align: "center",
        },
        { text: "Id consulta", value: "idMedicalPractice", align: "center" },
        { text: "Fecha consulta", value: "appointmentDate", align: "center" },
        { text: "Cancelado por", value: "nameDoctorCanceled", align: "center" },
        { text: "Fecha reporte", value: "cancellationDate", align: "center" },
        { text: "Razón", value: "reasonCanceled", align: "left", width: "280px" },
      ],
    },
    listReinterpretet: [],
    productsPrescription: [],
    selected: [],
    selectedMG: [],
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    params: {},
    model: {},
    status: [],
    model: { status: 0 },
    service: CancelledRequest,
    newStatusText: "",
  }),
  created() {
    this.validBrowserTab();
  },
  watch: {
    tab: function (newVal, oldVal) {
      this.selected = [];
      this.model.status = null;
      this.listAll();
    },
    selected: function (newVal, oldVal) {
      this.selectedMG = newVal.filter((item) => {
        const { studyModalityName, modalityName, lastStatus } = item;
        return ((this.$cnst.IS_MOMMOGRAPHY(studyModalityName) || this.$cnst.IS_MOMMOGRAPHY(modalityName)) && lastStatus == this.$cnst.STUDY_INTERPRETATING_STATUS) && this.$utilFront.isNull(item.statusSend );
    });
    },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError(e) {
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },
    viewTab(tab) {
      return this.tab == tab;
    },
    listAll() {
      let id = this.$utilFront.nonEmpty(
        this.idBranchOfficeSelected,
        this.$utilFront.getIdBranchOffice()
      );

      this.params = {
        idBranchOffice: id,
      };

      if (this.$utilFront.nonEmpty(this.date)) {           
        this.params.start = this.$utilFront.startOfDay(this.date.start);           
        this.params.end = this.$utilFront.endOfDay(this.date.end);         
      }

      this.newStatusText = "";

      switch (this.tab) {
        case 0: //Somatometry
          this.specialityName = "Somatometría";
          this.params.speciality = this.$cnst.SPECIALITY_CONSULTATION;
          this.newStatusText = "Pendiente";
          this.listAllSomatometry();
          break;
        case 1: //Medical Practice
          this.specialityName = "Consultas";
          this.params.speciality = this.$cnst.SPECIALITY_CONSULTATION;
          this.newStatusText = "Pendiente";
          this.listAllMedicalPractice()
          break;
        case 2: //Dental
          this.specialityName = "Dental"
          this.newStatusText = "Pendiente";
          this.params.speciality = this.$cnst.SPECIALITY_DENTAL;
          this.listAllDental();
          break;
        case 3: //Pharmacy
          this.specialityName = "Farmacia";
          this.newStatusText = "Por dispensar";
          this.listAllPharmacy();
          break;
        case 4: //Laboratory
          this.params.speciality = this.$cnst.SPECIALITY_LABORATORY;
          this.specialityName = "Laboratorio";
          this.listAllLaboratory();
          break;
        case 5: //Image
          this.params.speciality = this.$cnst.SPECIALITY_IMAGE;
          this.specialityName = "Imagen";
          this.listAllImage();
          break;
        case 6: //Psychology
          this.params.speciality = this.$cnst.SPECIALITY_PSYCHOLOGY;
          this.specialityName = "Psicología";
          this.newStatusText = "Pendiente";
          this.listAllPsychology();
          break;
        case 7: //Optometry
          this.params.speciality = this.$cnst.SPECIALITY_OPTOMETRY;
          this.specialityName = "Optometría";
          this.newStatusText = "Pendiente";
          this.listAllOptometry();
          break;
        case 8: //Optometry
          this.params.speciality = this.$cnst.SPECIALITY_AUDIOMETRY;
          this.specialityName = "Audiometría";
          this.newStatusText = "Pendiente";
          this.listAllAudiometry();
          break;
        case 9: //Telemedicine
          this.params.speciality = this.$cnst.SPECIALITY_TELEMEDICINE;
          this.specialityName = "Telemedicina";
          this.newStatusText = "Pendiente";
          this.listAllTelemedicine();
          break;
      }

      this.listStatusBySpecialty();
    },
    listAllSomatometry() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledAppointment(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.map((it) => {
              //it.appointmentDate = this.$utilFront.formatDateTime(it.startTime);
              it.cancelDate = this.$utilFront.formatDateTime(it.cancelDate) || "- - -";
              it.reason = it.reason || "- - -";
              it.studies = it.studies || "- - -";
              it.fullNameCancel = it.fullNameCancel || "- - -";
              it.idUnique = `${it.cancelDate} ${it.idPatient}`;
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllMedicalPractice() {
      // console.log(this.params);
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data
              .filter(it => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS) 
              .map(it => {
                it.appointmentDate = this.$utilFront.formatDateTime(it.appointmentDate);
                it.cancellationDate = this.$utilFront.formatDateTime(it.cancellationDate);
                return it;
              });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllDental() {
      this.sending = true;
      this.list = [];
      // console.log(this.params);
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllPharmacy() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledPrescription(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.map((it) => {
              it.prescriptionDate = this.$utilFront.formatDateTime(
                it.prescriptionDate
              );
              it.cancellationDate =
                this.$utilFront.formatDateTime(it.cancellationDate) || "- - -";
              it.reasonCanceled = it.reasonCanceled || "- - -";
              it.nameDoctorCanceled = it.nameDoctorCanceled || "- - -";
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllLaboratory() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledStudy(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.lastStatus !== this.$cnst.FROM_SOMATOMETRY_STATUS).map((it) => {
              it.registrationDate = this.$utilFront.formatDateTime(
                it.registrationDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              it.modality = it.modalityAcronym + " - " + it.modalityName;
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllImage() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledStudy(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.lastStatus !== this.$cnst.FROM_SOMATOMETRY_STATUS).map((it) => {
              it.registrationDate = this.$utilFront.formatDateTime(
                it.registrationDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              it.modality = it.modalityAcronym + " - " + it.modalityName;
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllPsychology() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllOptometry() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list =  data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listAllAudiometry() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },

    listAllColposcopy() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },

    listAllTelemedicine() {
      this.sending = true;
      this.list = [];
      this.service
        .listAllCancelledMedicalPractice(this.params)
        .then((res) => {
          let { data, code, status } = res.data;
          if (code == 200) {
            this.list = data.filter((it) => it.statusAppointment !== this.$cnst.FROM_SOMATOMETRY_APPOINTMENT_STATUS).map((it) => {
              it.appointmentDate = this.$utilFront.formatDateTime(
                it.appointmentDate
              );
              it.cancellationDate = this.$utilFront.formatDateTime(
                it.cancellationDate
              );
              return it;
            });
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
    listStatusBySpecialty() {
      this.status = [];
      let speciality = this.params.speciality;
      if (this.$utilFront.nonEmpty(speciality)) {
        SpecialityRequest.listStatusBySpecialty({ idSpeciality: speciality })
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && this.$utilFront.nonEmptyList(data)) {
              // this.status = data.map( (it) => { return { status: it.status, name: it.name}});
              this.status = data
                .filter((it) => it.reset)
                .map((it) => {
                  return { status: it.status, name: it.name };
                });
            }
          })
          .catch(this.$utilFront.errorhttp);
      }
    },
    viewStudy(item) {
      this.model = Object.assign(this.model, item);
      this.dialogInformation = true;
    },
    viewPrescription(item) {
      this.model = Object.assign(this.model, item);
      this.productsPrescription = [];

      if (!this.sending) {
        this.sending = true;
        let data = { idPrescription: item.idPrescription };
        PharmacyPrescriptionRequest.listPharmacyPrescriptionByPrescription(data)
          .then((res) => {
            let { code, data } = res.data;
            if (code == 200) {
              this.productsPrescription = data.map((it) => {
                return {
                  idProduct: it.products.idProduct,
                  product_key: it.products.product_key,
                  name: it.products.name,
                  text: it.products.text,
                  request: it.request,
                  dispensed: it.dispensed,
                };
              });
            }
          })
          .catch(this.$utilFront.errorhttp)
          .finally(() => {
            this.sending = false;
            this.dialogInformation = true;
          });
      }
    },
    downloadViewer() {
      try {
        this.sending = true;
        let data = {
          idStudy: this.model.idStudy,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    downloadZIP() {
      this.sending = true;
      let data = { idStudy: this.model.idStudy };
      DownloadZipRequest.downloadImagesDCM(data)
        .then((res) => {
          if (res.status == 200) {
            const url = URL.createObjectURL(
              new Blob([res.data], {
                type: "application/zip",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              "Estudio " + this.model.idStudy + ".zip"
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        // .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    updateStatus() {
      if (this.$utilFront.nonEmptyList(this.selected)) {
        switch (this.tab) {
          case 0: //Somatometry
            this.updateStatusAppointment();
            break;
          case 1:
          case 2: //Medical practice / dental
            this.updateStatusMedicalPractrice();
            break;
          case 3: //Pharmacy
            this.updateStatusPrescription();
            break;
          case 4:
          case 5: //Laboratory / image
            this.updateStatusStudy();
            break;
          case 6: //Medical practice / Psychology
            this.updateStatusPsychology();
            break;
          case 7: //Medical practice / Optometry
            this.updateStatusOptometry();
            break;
          case 8: //Medical practice / Audiometry
            this.updateStatusAudiometry();
            break;
          case 9: //Medical practice / Colposcopy
            this.updateStatusColposcopy();
            break;
            case 10: //Medical practice / Telemedicine
            this.updateStatusTelemedicine();
            break;
        }
      } else {
        this.$utilFront.notifications(
          "Seleccione un elemento de la tabla.",
          "WARNING"
        );
      }
    },
    sendSynch() {
      if (!this.sending) {
        this.sending = true;

        let idsStudy = this.selectedMG.map((it) => {
          return { idStudy: it.idStudy };
        });

        CamujalService.sendStudyDiscarted(idsStudy).then((response) => {
          this.listAllImage();
          this.$utilFront.notifications("Estudio(s) enviado.", "SUCCESS");

        })
          .catch(this.$utilFront.errorhttp)
          .finally(() => {
            this.sending = false;
            this.dialogSend = false;
            this.selected = [];
            this.selectedMG = [];
          });
      }
    },
    responseUpdateStatus(responseHTTP) {
      let { data, response, message } = responseHTTP.data;
      if (response == true) {
        this.dialogUpdateStatus = false;
        this.$utilFront.notifications("Estatus actualizado.", "SUCCESS");
        this.listAll();
      } else {
        this.$utilFront.notifications(
          message || "Error actualizado el estatus",
          "ERROR"
        );
      }
    },
    finallyUpdateStatus() {
      this.sending = false;
    },
    updateStatusAppointment() {
      if (!this.sending) {
        this.sending = true;
        let haydis = [];
        for (let i = 0; i < this.selected.length; i++) {
          const element = this.selected[i];
          haydis.push(...element.idsAppointment);
        }
        // console.log(haydis);

        // // let haydis = this.selected.map((it) => {
        // //   console.log(it)
        // //   return it.idAppointment;
        // // });

        this.sending = true;
        this.service
          .updateStatusListAppointment({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusMedicalPractrice() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusPrescription() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idPrescription;
        });
        this.service
          .updateStatusListPrescription({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusStudy() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idStudy;
        });
        this.service
          .updateStatusListStudy({ idList: haydis, status: this.model.status })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusPsychology() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusOptometry() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusAudiometry() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusColposcopy() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    updateStatusTelemedicine() {
      if (!this.sending) {
        this.sending = true;
        let haydis = this.selected.map((it) => {
          return it.idMedicalPractice;
        });
        this.service
          .updateStatusListMedicalPractice({ idList: haydis })
          .then(this.responseUpdateStatus)
          .catch(this.$utilFront.errorhttp)
          .finally(this.finallyUpdateStatus);
      }
    },
    clearCalendar() {
      this.date = "";
      this.listAll();
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
  },
};
</script>
 <style>

</style> 
